<template>
  <button class="d-btn-upload" type="button">
    <slot></slot>
    <input type="file" @change="onchange($event)">
  </button>
</template>

<script>
  // let host = 'https://we-oss.oss-cn-shanghai.aliyuncs.com/'
  // import Crypto from 'crypto-js'

  export default {
    data () {
      return {
        uploading: false
      }
    },
    props: {
      url: {
        twoWay: true
      },
      cal: Function
    },
    methods: {
      onchange (event) {
        const files = event.srcElement.files
        if (this.uploading || !files.length) {
          return
        }

        this.uploading = true

        let formData = new window.FormData()
        formData.append('file', files[0], files[0].name)
        formData.append('scene', 'sku')

        this.$http.post(`${process.env.ACCOUNT_API}/admin/upload/public`, formData)
          .then(({ data }) => {
            console.log(data.data.url)
            this.url = 'https:' + data.data.url
            this.$emit('callback', this.url)
            this.cal && this.cal(this.url)
          }, (e) => {
            window.alert('上传失败')
          })
          .finally(() => {
            this.uploading = false
          })
      }
    }
  }
</script>

<style scoped>
  .d-btn-upload {
    position: relative;
    overflow: hidden;
  }
  .d-btn-upload input {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    font-size: 100px;
    cursor: pointer;
    opacity: 0;
  }
</style>



/** WEBPACK FOOTER **
 ** Upload.vue?fb673038
 **/